import { render, staticRenderFns } from "./TwigMessages.vue?vue&type=template&id=2f7b525c&scoped=true"
import script from "./TwigMessages.vue?vue&type=script&lang=js"
export * from "./TwigMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b525c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseAlert.vue').default})
